import React from 'react';
import Layout from '../components/layout/Layout';
import BookingForm from '../components/booking/BookingForm';
import StickyBookingButton from '../components/booking/StickyBookingButton';

const BookingPage: React.FC = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Book Your Stay</h1>
        <div className="bg-white rounded-lg shadow-lg p-6">
          <BookingForm isAuthenticated={false} />
        </div>
      </div>
      <StickyBookingButton />
    </Layout>
  );
};

export default BookingPage;
